type CommentFilePayload = {
  content: string;
  name: string;
  targetField: string;
};

export function fileToBase64Content(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('FileReader error'));
    reader.onload = () => {
      const result = String(reader.result ?? '');
      const base64 = result.includes(',') ? result.split(',')[1] : result;
      resolve(base64);
    };
    reader.readAsDataURL(file);
  });
}

export async function buildCommentFiles(
  attached: { file: File }[],
  targetField = 'comment'
): Promise<CommentFilePayload[]> {
  const payloads = await Promise.all(
    attached.map(async ({ file }) => ({
      name: file.name,
      targetField,
      content: await fileToBase64Content(file),
    }))
  );
  return payloads;
}
